import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import ButtonOption from "../ButtonOption";
import { useAppData } from "../../context/Contexts";
import VehicleAddons from "../VehicleAddons";
import {
    applyPriceTest26CoverageOverride,
    formatMoney,
    formatSelectedSeat, formatShopifyMoney, getCompareOfferPrice,
    getCurrency, getOfferPrice, getPriceElem,
    getJumpSeatCoverId,
    isCustom,
    isCustomFront,
    isCustomFrontJump, isCustomJump,
    isCustomThreeRows, parsedSeatUserFriendly,
    isCustomRearAvailable,
    getCustomRearOptions,
    resolveAvailabilitySeatKey,
    matchesSetupHint,
    sanitizeHtml,
} from "../../helpers/helpers";
import React, { useState, useEffect, useRef } from "react";
import fetchCheck from "../../services/CheckService";
import SuperOffer from "../SuperOffer";
import { useShopifyVariantLookup } from "../../hooks/useShopifyVariantLookup";

function getNewSeatValue(currentValue: string, isChecked: boolean, currentAppData: {
    step: number | undefined;
    seat: string;
    color: string;
    selectedId: number | undefined;
    year: number;
    make: string;
    model: string;
    check: { compatibility: string; compatibility_custom: string; availability: object } | undefined;
    product: object | undefined;
    originalProduct: object | undefined
} | null) {

    let new_value = currentValue;

    let custom_disabled = false;

    if (currentAppData && currentAppData?.check?.compatibility !== 'N') {
        custom_disabled = true;
    }


    // console.log('cccc', !custom_disabled, currentAppData?.check?.compatibility_custom);
    if (!custom_disabled && currentAppData?.check?.compatibility_custom === 'T') {
        let old_value = currentAppData?.seat;
        if (!old_value) {
            old_value = '';
        }
        if (old_value === 'Bundle') {
            old_value = '';
        }
        const parts = old_value.split(',');
        if (isChecked) {
            parts.push(currentValue);
            new_value = parts.filter(v => v.trim() != '').join(',');
        } else {
            const index = parts.indexOf(currentValue);
            const x = parts.splice(index, 1).filter(v => v.trim() != '');
            new_value = x.join(',');
        }
        const p1 = new_value.split(',');

        if (p1.includes('First Row') && p1.includes('Middle Row') && p1.includes('Back Row')) {
            new_value = 'Bundle';
        }
        if (currentValue === 'Bundle') {
            new_value = 'Bundle';
        }

    }
    /*if (!custom_disabled &&
        (currentAppData?.check?.compatibility_custom === 'Y'
            || currentAppData?.check?.compatibility_custom === 'YF')) {

        if (p1.length === 2 && p1.includes('First Row') && p1.includes('Back Row')) {
            new_value = 'Bundle';
        }
    }*/
    return new_value;
}

export default function Step3New(props) {
    const { currentAppData, setCurrentAppData } = useAppData();

    const [options, setOptions] = useState([]);
    const [product, setProduct] = useState({});
    const [comparePrice, setComparePrice] = useState('');
    const [comparePrice1, setComparePrice1] = useState('');
    const [savings, setSavings] = useState<undefined | string>(undefined);
    const [savings1, setSavings1] = useState<undefined | string>(undefined);

    useEffect(() => {
        let timerId: ReturnType<typeof setTimeout> | undefined;
        if (currentAppData === null) {
            return;
        }
        // Don't run seat fallback or any state-changing logic while a check is already in flight
        if (currentAppData.isFetchingCheck) {
            return;
        }
        // Don't auto-select a seat when vehicle fields have been cleared (e.g. user pressed back on Step1)
        if (!currentAppData?.year || !currentAppData?.make || !currentAppData?.model) {
            return;
        }
        let product1: any;
        if (currentAppData.check && currentAppData.check.compatibility === 'N') {
            product1 = currentAppData.product;
        } else {
            product1 = currentAppData.originalProduct;
        }
        if (product1 && product1.options) {
            setProduct(product1);
            const seatsOptions = product1.options.filter(option => option.name === 'Seats');
            setOptions(seatsOptions);

            // If current seat is not present or not available in the displayed product options, select first available option
            if (currentAppData) {
                const availability = (currentAppData.check && typeof currentAppData.check.availability !== 'undefined')
                    ? (currentAppData.check.availability ?? {}) : {};
                // seatName is a raw Shopify option value — resolve through the alias
                // table (Bundle <-> Front and Universal Rear Seats, etc.) instead of
                // indexing availability directly, same reasoning as the enabled check
                // in the render loop below.
                const isSeatAvailable = (seatName: string) => {
                    const availKey = resolveAvailabilitySeatKey(seatName, availability);
                    return availability[availKey] && Object.values(availability[availKey]).some((val: any) => val === true);
                };

                const optionValues = seatsOptions.length > 0 ? seatsOptions[0].optionValues : [];
                const names: string[] = optionValues.map((v: any) => v.name);

                // Compute the set of option names that are actually rendered/visible,
                // applying the same filter conditions used in the JSX render below.
                // This ensures that seats hidden for fronts-only vehicles (e.g. 'Bundle'
                // hidden when only 'Front Seats' is displayed) are not considered valid.
                const compat = currentAppData.check?.compatibility;
                const isFrontsOnlyRegular = (compat === 'F' || compat === 'HF' || compat === 'AF' || compat === 'BF');
                const isFrontsOnlyCustom = isCustomFront(currentAppData);
                const visibleNames: string[] = names.filter((name: string) => {
                    if (isFrontsOnlyRegular && name !== 'Front Seats') return false;
                    if (isFrontsOnlyCustom && name !== 'First Row') return false;
                    return true;
                });
                // Use visible names for validation when a fronts-only filter restricts options.
                const effectiveNames = (isFrontsOnlyRegular || isFrontsOnlyCustom) && visibleNames.length > 0
                    ? visibleNames
                    : names;

                const seatMissingFromDisplayed = !currentAppData.seat || !effectiveNames.includes(currentAppData.seat);
                // 'Bundle' (or any seat) may exist in the list but have no available colors.
                // Skip availability check for custom product (compatibility === 'N') because
                // check.availability is keyed by the original product's seat names, not the custom product's.
                const isCustomProduct = currentAppData.check && currentAppData.check.compatibility === 'N';
                // For 'Y' compatibility the VehicleConfigurator determines real availability
                // via its questions; don't auto-switch away based on check.availability alone.
                const seatUnavailableInDisplayed = !isCustomProduct &&
                    !seatMissingFromDisplayed &&
                    currentAppData?.check?.compatibility !== 'Y' &&
                    Object.keys(availability).length > 0 &&
                    !isSeatAvailable(currentAppData.seat);

                // In biz2 stepper (non-fronts-only), don't auto-select when no seat is set —
                // the user must choose explicitly. Still allow fallback when a seat is set
                // but no longer valid (e.g. vehicle changed, fronts-only restriction applied).
                // A "?setup=front|rear|bundle" URL param lets a deep link nudge the
                // fallback below toward a specific seat configuration on first load.
                const setupHint = new URLSearchParams(window.location.search).get('setup')?.trim().toLowerCase() || null;
                const isBiz2Flow = !!(window.scs_new_design_2026 && window.scs_biz2);
                const skipInitialAutoSelect = isBiz2Flow && !currentAppData.seat && !setupHint;

                if (!skipInitialAutoSelect && (seatMissingFromDisplayed || seatUnavailableInDisplayed)) {
                    // Select among the visible/effective options so we don't auto-select a
                    // hidden option (e.g. 'Bundle' on a fronts-only vehicle).
                    const candidateValues = optionValues.filter((v: any) => effectiveNames.includes(v.name));
                    const candidates = candidateValues.length > 0 ? candidateValues : optionValues;
                    if (candidates.length > 0) {
                        let firstAvailable = candidates[0].name;
                        const firstActive = candidates.map((v: any) => v.name).find(isSeatAvailable);
                        if (firstActive) {
                            firstAvailable = firstActive;
                        }
                        if (setupHint) {
                            const hinted = candidates
                                .map((v: any) => v.name)
                                .find((name: string) => matchesSetupHint(name, setupHint) && isSeatAvailable(name));
                            if (hinted) {
                                firstAvailable = hinted;
                            }
                        }
                        timerId = setTimeout(() => { setNewSeatValue(firstAvailable, firstAvailable); }, 0);
                    }
                } else if (
                    // If seat is valid in the displayed product but missing or unavailable in the custom product
                    // (used by setNewSeatValue when compatibility_custom !== 'N'), fall back to first available.
                    // Skip when isCustomProduct: the custom product is already the primary displayed product above,
                    // and check.availability is keyed by original seat names so isSeatAvailable would always fail.
                    !skipInitialAutoSelect &&
                    !isCustomProduct &&
                    currentAppData.check &&
                    currentAppData.check.compatibility_custom !== 'N' &&
                    currentAppData.product &&
                    (currentAppData.product as any).options
                ) {
                    const customSeatsOptions = (currentAppData.product as any).options.filter((o: any) => o.name === 'Seats');
                    const customOptionValues: string[] = customSeatsOptions.length > 0
                        ? customSeatsOptions[0].optionValues.map((v: any) => v.name)
                        : [];
                    const seatMissingFromCustom = customOptionValues.length > 0 && !customOptionValues.includes(currentAppData.seat);
                    const seatUnavailableInCustom = !seatMissingFromCustom &&
                        customOptionValues.length > 0 &&
                        Object.keys(availability).length > 0 &&
                        !isSeatAvailable(currentAppData.seat);

                    if (seatMissingFromCustom || seatUnavailableInCustom) {
                        let firstAvailableCustom = customOptionValues[0];
                        const firstActive = customOptionValues.find(isSeatAvailable);
                        if (firstActive) {
                            firstAvailableCustom = firstActive;
                        }
                        timerId = setTimeout(() => { setNewSeatValue(firstAvailableCustom, firstAvailableCustom); }, 0);
                    }
                }
            }
            // console.log('product options', options);
        }
        return () => { if (timerId) clearTimeout(timerId); };
    }, [currentAppData?.check, currentAppData?.product, currentAppData?.originalProduct, currentAppData?.isFetchingCheck])


    const handleChange = async (e) => {
        const new_value = e.target.value;

        if (showCustomRearCheckboxes && !e.target.checked) {
            const rearAddons = currentAppData?.customRearAddons || [];
            if (rearAddons.length === 0) return;
            setCurrentAppData(prevState => ({ ...prevState, seat: '' }));
            return;
        }

        const new_seat_value = getNewSeatValue(new_value, e.target.checked, currentAppData);

        setNewSeatValue(new_value, new_seat_value);
    }

    const setNewSeatValue = async (new_value: string, new_seat_value: string) => {
        let product = currentAppData.originalProduct;
        if (currentAppData.check && currentAppData.check.compatibility_custom !== 'N') {
            product = currentAppData.product;
        }

        // console.log('product step2', product);
        const filtered = product && product.variants && product.variants.edges.length > 0 ?
            product.variants.edges.filter(el => el.node.title.indexOf(new_value) === 0) : [];
        // console.log('filtered step2', filtered);
        if (filtered.length > 0) {

            applyPriceTest26CoverageOverride(filtered[0].node, new_value, currentAppData);

            const currency = getCurrency(filtered[0].node.priceV2.currencyCode);
            //setPrice(currency + '' + formatMoney(parseFloat(filtered[0].node.priceV2.amount)));


            if (filtered[0].node.compareAtPrice) {
                setComparePrice(currency + '' + filtered[0].node.compareAtPrice.amount);
                setComparePrice1(filtered[0].node.compareAtPrice.amount);
                setSavings1(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount));
                setSavings(currency + '' + formatMoney(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount)));
            } else {
                if (window.scs_show_earlybf_section || window.scs_father_day_2026) {
                    setSavings(currency + '' + formatMoney(20));
                } else {
                    setSavings(undefined);
                }
            }
        } else {
            setSavings(undefined);
        }

        

        setCurrentAppData(prevState => {
            return { ...prevState, seat: new_seat_value, isFetchingCheck: true }
        })

        const check = await fetchCheck(currentAppData?.year, currentAppData?.make, currentAppData?.model, currentAppData?.trim,
            currentAppData?.color, new_seat_value, currentAppData?.cab, 'change_seat');
        setCurrentAppData(prevState => {
            // Advance step when seat is selected.
            // In biz2 new design: advance from seat-type step (2) to color step (3) when
            // seat is selected and configurator (if any) is not blocking.
            // Otherwise: advance from step 1 to step 2 as before.
            const trimOk = !prevState.has_trims || (prevState.trim && prevState.trim !== '');
            const cabOk = !prevState.has_cabs || (prevState.cab && prevState.cab !== '');
            let nextStep = prevState.step;
            if (trimOk && cabOk) {
                if (window.scs_new_design_2026 && window.scs_biz2 && prevState.step === 2) {
                    nextStep = 3;
                } else if (prevState.step < 2) {
                    nextStep = 2;
                }
            }
            return { ...prevState, check: check, isFetchingCheck: false, step: nextStep };
        });
    }

    const handleClickChange = (e) => {
        // console.log('handleClickChange 2');
        setCurrentAppData(prevState => {
            return {
                ...prevState,
                step: isBiz2Stepper ? activeStepNum : 2,
                seat: '',
                color: 'Black',
                // reset following steps: configurator + color
                configurator_complete: false,
                biz2_coverages: null,
                addons: '',
            }
        })
    }

    const handleAddonChange = (e) => {
        // console.log('handleAddonChange', currentAppData?.addons);
        // console.log('isChecked', e.target.checked);
        const currentValue = e.target.value;
        let new_value = currentAppData?.addons;

        if (!currentAppData?.addons) {
            new_value = currentValue;
        } else {

            const parts = new_value?.split(',');
            const isChecked = e.target.checked;


            if (isChecked) {
                parts?.push(currentValue);
                new_value = parts?.filter(v => v.trim() != '').join(',');
            } else {
                const index = parts?.indexOf(currentValue);
                // console.log('index', index);
                if (index != undefined && index !== -1) {
                    const x = parts.splice(index + 1, 1).filter(v => v.trim() != '');
                    // console.log('new_value x', x);
                    new_value = x.join(',');
                }
            }
        }

        // console.log('handleAddonChange', new_value);

        setCurrentAppData(prevState => {
            return { ...prevState, addons: new_value }
        })
    }

    const showCustomDrawer = (e) => {


    }

    // console.log('StepUpsells: ', currentAppData);

    const handleChangeUltimateUpgrade = () => {
        setCurrentAppData(prevState => {
            return { ...prevState, ultimate_upgrade: !prevState.ultimate_upgrade }
        })
    };

    // Jeep Wrangler seat selector
    const isJeepWranglerMode = !!(window.scs_jeep_wrangler
        && currentAppData?.make === 'Jeep'
        && currentAppData?.model?.includes('Wrangler'));
    const frontSeatValueJW = isJeepWranglerMode
        ? ((currentAppData?.check?.compatibility !== 'N') ? 'Front Seats' : 'First Row')
        : '';
    const isJeepRearAddon = !!(isJeepWranglerMode && currentAppData?.addons?.split(',').includes('Back Row'));

    const handleJeepRearAddonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const parts = (currentAppData?.addons || '').split(',').filter(v => v.trim() !== '');
        const updated = e.target.checked
            ? [...parts.filter(v => v !== 'Back Row'), 'Back Row'].join(',')
            : parts.filter(v => v !== 'Back Row').join(',');
        setCurrentAppData(prevState => ({ ...prevState, addons: updated }));
    };

    const showCustomRearCheckboxes = isCustomRearAvailable(currentAppData);
    const customRearOptions = showCustomRearCheckboxes
        ? getCustomRearOptions(currentAppData?.check?.compatibility_custom)
        : [];
    const selectedCustomRearAddons = currentAppData?.customRearAddons || [];

    // Mirrors the per-seat condition that renders the Jump Seat Cover
    // ButtonOption below (isCustomJump + FJ/YJ/TJ), without needing a
    // specific el.name to check against.
    const hasJumpSeatAddon = isCustomJump(currentAppData) && (
        currentAppData.check?.compatibility_custom === 'FJ'
        || currentAppData.check?.compatibility_custom === 'YJ'
        || currentAppData.check?.compatibility_custom === 'TJ'
    );

    // Color isn't chosen yet at this step (color selection is a later step in
    // this flow) — getJumpSeatCoverId already falls back to the Black variant
    // when no color is set, which is fine here since this addon's price
    // doesn't vary by color, only the SKU does. Falls back to the static
    // $199.99 if the live variant hasn't loaded yet or the fetch fails.
    const jumpSeatCoverVariantId = hasJumpSeatAddon ? getJumpSeatCoverId(currentAppData?.color) : undefined;
    const { data: jumpSeatCoverVariant } = useShopifyVariantLookup(jumpSeatCoverVariantId);
    const jumpSeatCoverPrice = jumpSeatCoverVariant?.price
        ? formatShopifyMoney(parseFloat(jumpSeatCoverVariant.price))
        : formatShopifyMoney(199.99);

    const handleCustomRearAddonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const key = e.target.value;
        const current = currentAppData?.customRearAddons || [];
        const updated = e.target.checked
            ? [...current, key]
            : current.filter(v => v !== key);
        if (!e.target.checked && updated.length === 0 && !currentAppData?.seat) return;
        setCurrentAppData(prevState => {
            // Mirror setNewSeatValue's step advance so checking the rear addon
            // alone (without also checking Front Seats) still unlocks color.
            const trimOk = !prevState.has_trims || (prevState.trim && prevState.trim !== '');
            const cabOk = !prevState.has_cabs || (prevState.cab && prevState.cab !== '');
            let nextStep = prevState.step;
            if (e.target.checked && trimOk && cabOk && window.scs_new_design_2026 && window.scs_biz2 && prevState.step === 2) {
                nextStep = 3;
            }
            return { ...prevState, customRearAddons: updated, step: nextStep };
        });
    };

    const getCustomRearOptionPrice = (optionKey: string) => {
        const rearProduct = currentAppData?.customRearProduct;
        if (!rearProduct || !rearProduct.variants) return null;

        const seatName = optionKey === 'rear_seat' ? 'Custom 2nd Row'
            : optionKey === '2nd_row' ? 'Custom 2nd Row'
            : 'Custom 3rd Row';

        const variants = rearProduct.variants.edges || [];
        const matchingVariant = variants.find(v =>
            v.node.selectedOptions.some(o => o.name === 'Seats' && o.value === seatName)
        );

        if (matchingVariant) {
            return {
                price: formatShopifyMoney(parseFloat(matchingVariant.node.priceV2.amount)),
                comparePrice: matchingVariant.node.compareAtPrice
                    ? formatShopifyMoney(parseFloat(matchingVariant.node.compareAtPrice.amount))
                    : null,
            };
        }
        return null;
    };
    let jeepFrontPrice = '';
    let jeepFrontComparePrice = '';
    let jeepRearPrice = '';
    let jeepRearComparePrice = '';
    if (isJeepWranglerMode && product && (product as any).variants) {
        const fpEl = getPriceElem((product as any).variants, frontSeatValueJW, currentAppData);
        if (fpEl.length > 0) {
            jeepFrontPrice = formatShopifyMoney(formatMoney(getOfferPrice(parseFloat(fpEl[0].node.priceV2.amount))));
            if (fpEl[0].node.compareAtPrice) {
                jeepFrontComparePrice = formatShopifyMoney(formatMoney(getCompareOfferPrice(parseFloat(fpEl[0].node.priceV2.amount), parseFloat(fpEl[0].node.compareAtPrice.amount))));
            }
        }
        const rearVariants = currentAppData?.check?.compatibility !== 'N'
            ? (currentAppData?.product as any)?.variants
            : (product as any).variants;
        if (rearVariants) {
            const rpEl = getPriceElem(rearVariants, 'Back Row', currentAppData);
            if (rpEl.length > 0) {
                jeepRearPrice = formatShopifyMoney(formatMoney(getOfferPrice(parseFloat(rpEl[0].node.priceV2.amount))));
                if (rpEl[0].node.compareAtPrice) {
                    jeepRearComparePrice = formatShopifyMoney(formatMoney(getCompareOfferPrice(parseFloat(rpEl[0].node.priceV2.amount), parseFloat(rpEl[0].node.compareAtPrice.amount))));
                }
            } else {
                jeepRearPrice = jeepFrontPrice;
                jeepRearComparePrice = jeepFrontComparePrice;
            }
        } else {
            jeepRearPrice = jeepFrontPrice;
            jeepRearComparePrice = jeepFrontComparePrice;
        }
    }

    const isBiz2Stepper = !!(window.scs_new_design_2026 && window.scs_biz2);
    const activeStepNum = isBiz2Stepper ? (props.stepNumber ?? 3) : 2;
    // Keep this step expanded (never collapse to the one-line summary) when
    // custom rear seats are available, or when the Jump Seat Cover addon is
    // — in both cases the seat and the addon are independent checkboxes, so
    // the user needs both visible/toggleable even after advancing to color.
    const isStepSummary = isBiz2Stepper && (currentAppData?.step ?? 0) > activeStepNum && !showCustomRearCheckboxes && !hasJumpSeatAddon;
    const isStepHidden  = isBiz2Stepper && (currentAppData?.step ?? 0) < activeStepNum;

    if (isStepHidden) return (
        <section className={`${styles.section__step} ${styles.section_locked} ${window.scs_new_design_2026 ? styles.scs_new_design_2026 : ''}`}>
            <h2><span className={`${styles.section__step_no}`}>{props.stepNumber ?? 3}</span></h2>
            <div className={`${styles.selector_wrapper}`}>
                <strong><span className={`${styles.section__step_no}`}>{props.stepNumber ?? 3}</span>Choose Your Setup</strong>
            </div>
        </section>
    );

    return (<>

        <>
            <section className={`${styles.section__step} ${window.scs_custom_style ? styles.style01 : ''} ${(isBiz2Stepper ? currentAppData?.step == activeStepNum : currentAppData?.step == 2) ? styles.section_active : ''}
                ${window.scs_ultimate_upgrade ? styles.has_ultimate : ''} ${window.scs_black_friday_2025 ? styles.has_bf_2025 : ''}  ${window.scs_new_design_2026 ? styles.scs_new_design_2026 : ''}`}
                id="step_3">
                <h2><span className={`${styles.section__step_no} ${isStepSummary ? styles.section__step_no_done : ''}`}>{props.stepNumber ?? 3}</span></h2>

                <div className={`${styles.selector_wrapper}`}>
                    <strong><span className={`${styles.section__step_no} ${isStepSummary ? styles.section__step_no_done : ''}`}>{props.stepNumber ?? 3}</span>Choose Your Setup</strong>

                    {isStepSummary ? (
                        <div className={`${styles.summary}`}>
                            <div className={`${styles.selected_value}`}>{parsedSeatUserFriendly(formatSelectedSeat(currentAppData?.seat, product, currentAppData?.check?.compatibility_custom, currentAppData), currentAppData?.check?.compatibility_custom, currentAppData)}</div>
                            <button type="button" className={`${styles.btn_change}`} onClick={handleClickChange} aria-label="Edit seat selection">
                                <svg width="14" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0.274589 0.274547C0.640708 -0.0915156 1.2343 -0.0915156 1.60041 0.274547L7.1875 5.86167L12.7746 0.274547C13.1407 -0.0915156 13.7343 -0.0915156 14.1004 0.274547C14.4665 0.640672 14.4665 1.2343 14.1004 1.60042L7.85044 7.85042C7.48431 8.21648 6.89069 8.21648 6.52456 7.85042L0.274589 1.60042C-0.0915297 1.2343 -0.0915297 0.640672 0.274589 0.274547Z" fill="black"/></svg>
                            </button>
                        </div>
                    ) : (<>

                    <div className={`${styles.modal}`} id="leftModal" aria-hidden="true">
                        <div className={`${styles.modalDialog}`}>
                            <div className={`${styles.modalHeader}`}>
                                <h2>Custom Cover Solution</h2>
                                <a href="#" className={`${styles.btnClose}`} aria-hidden="true">×</a>
                            </div>
                            <div className={`${styles.modalBody}`}
                                dangerouslySetInnerHTML={{ __html: sanitizeHtml(window.custom_solution_body) }}>
                            </div>
                            {/*<div className={`${styles.modalFooter}`}>*/}
                            {/*    <a href="#" className={`${styles.btn}`}>Nice!</a>*/}
                            {/*</div>*/}
                        </div>
                    </div>


                    {isJeepWranglerMode && (
                        <div className={`${styles.seat_type_selector}`}>
                            <div className={`${styles.button_option} ${styles.checked}`}>
                                <label htmlFor="jwsel_fronts">
                                    <div className="form_control">
                                        <input type="radio" name="JWSeat" value={frontSeatValueJW} id="jwsel_fronts"
                                            checked={true}
                                            onChange={() => {}} />
                                    </div>
                                    <div className={`${styles.content_wrapper}`}>
                                        <div className={`${styles.title_wrapper}`}>
                                            <div className={`${styles.title}`}>Fronts Only</div>
                                        </div>
                                        <div className={`${styles.priceContainer}`}>
                                            <div className={`${styles.innerPriceContainer}`}>
                                                <div className={`${styles.price_wrapper}`}>
                                                    {jeepFrontComparePrice && <div className={`${styles.compare_price}`} data-testid="jeep-fronts-compare-price">{jeepFrontComparePrice}</div>}
                                                    {jeepFrontPrice && <div className={`${styles.price}`} data-testid="jeep-fronts-price">{jeepFrontPrice}</div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div className={`${styles.button_option} ${isJeepRearAddon ? styles.checked : ''}`}>
                                <label htmlFor="jwsel_rear">
                                    <div className="form_control">
                                        <input type="checkbox" name="Addons[]" value="Back Row" id="jwsel_rear"
                                            checked={isJeepRearAddon}
                                            onChange={handleJeepRearAddonChange} />
                                    </div>
                                    <div className={`${styles.content_wrapper}`}>
                                        <div className={`${styles.title_wrapper}`}>
                                            <div className={`${styles.title}`}>Rear Only</div>
                                            <div className={`${styles.sub_title}`}>Custom Made — 3–4 Week Production</div>
                                        </div>
                                        <div className={`${styles.priceContainer}`}>
                                            <div className={`${styles.innerPriceContainer}`}>
                                                <div className={`${styles.price_wrapper}`}>
                                                    {jeepRearComparePrice && <div className={`${styles.compare_price}`} data-testid="jeep-rear-compare-price">{jeepRearComparePrice}</div>}
                                                    {jeepRearPrice && <div className={`${styles.price}`} data-testid="jeep-rear-price">{jeepRearPrice}</div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    )}
                    {!isJeepWranglerMode && <div
                        className={`${styles.seat_type_selector} ${localStyles.seat_selector} ${isCustom(currentAppData) ? '' : ''} ${options.length > 0 && Array.from(
                            new Map(options[0].optionValues.map(item => [item.id, item])).values()
                        ).length === 3 && !(currentAppData?.check?.compatibility === 'HF' || currentAppData?.check?.compatibility === 'AF' || currentAppData?.check?.compatibility === 'F' || currentAppData?.check?.compatibility === 'BF') ? '' : ''}`}>
                        {options.length > 0 && Array.from(
                            new Map(options[0].optionValues.map(item => [item.id, item])).values()
                        ).map(el => {
                            let price = '';
                            let comparePrice = '';
                            const priceEl = getPriceElem(product.variants, el.name, currentAppData);
                            // console.log('priceEl:', priceEl);
                            if (priceEl.length > 0) {
                                const currency = getCurrency(priceEl[0].node.priceV2.currencyCode);
                                price = formatShopifyMoney(formatMoney(getOfferPrice(parseFloat(priceEl[0].node.priceV2.amount))));

                                if (priceEl[0].node.compareAtPrice) {
                                    comparePrice = formatShopifyMoney(formatMoney(getCompareOfferPrice(parseFloat(priceEl[0].node.priceV2.amount), parseFloat(priceEl[0].node.compareAtPrice.amount))));
                                } else {
                                    if (window.scs_show_earlybf_section) {
                                        comparePrice = formatShopifyMoney(formatMoney(parseFloat(priceEl[0].node.priceV2.amount)));
                                    }
                                }
                            }

                            //DONE: check compatibility and show button if there is any color available for this seat (el.name)
                            let enabled = false;
                            if (currentAppData?.check?.compatibility === 'Y' || currentAppData?.check?.compatibility_custom !== 'N') {
                                enabled = true;
                            } else {
                                if (currentAppData.check && typeof currentAppData.check.availability !== 'undefined') {
                                    // el.name is the raw Shopify option value — on universal (see isUniversalBundle)
                                    // vehicles that's "Front and Universal Rear Seats"/"Universal Rear Seats Only"
                                    // rather than "Bundle"/"Universal Back Bench", so resolve through the alias
                                    // table instead of indexing check.availability directly (see helpers.tsx).
                                    const availKey = resolveAvailabilitySeatKey(el.name, currentAppData.check.availability);
                                    enabled = currentAppData.check.availability[availKey] && Object.keys(currentAppData.check.availability[availKey])
                                        .filter(v => currentAppData?.check?.availability[availKey][v]).length > 0;
                                }
                            }

                            //DONE: add option to make button checkboxes (for custom product)

                            //DONE: after selecting vehicle - before moving to step 2 we need to do a check and populate check property of the state
                            if ((currentAppData?.check?.compatibility === 'HF' || currentAppData?.check?.compatibility === 'AF' || currentAppData?.check?.compatibility === 'F' || currentAppData?.check?.compatibility === 'BF') && el.name !== 'Front Seats') {
                                return (<></>);
                            }

                            if (isCustomFront(currentAppData) && el.name !== 'First Row') {
                                return (<></>);
                            }

                            let display = (!(isCustom(currentAppData) && el.name.indexOf('Row & ') !== -1));

                            if (currentAppData?.check?.compatibility === 'N' && (currentAppData?.check?.compatibility_custom === 'Y' || isCustomJump(currentAppData))) {
                                if (el.name.indexOf('Middle Row') !== -1) {
                                    display = false;
                                }
                                if (el.name.indexOf('3 Row Bundle') !== -1) {
                                    display = false;
                                }
                                if (el.name.indexOf('2 Row Bundle') !== -1) {
                                    display = true;
                                }
                            }

                            const id = 'btn_' + el.id.replace('gid://shopify/ProductOptionValue/', '');

                            if (window.scs_ultimate_upgrade
                                && (el.name === 'Universal Rear Seats Only' 
                                    || el.name === 'Universal Back Bench' 
                                    || el.name === 'Back Bench' 
                                    || el.name === 'Back Row')
                            ) {
                                return (<></>);

                            }

                            return (<React.Fragment key={`wrapper-${el.id}`}><ButtonOption key={el.id}
                                comparePrice={comparePrice}
                                price={price}
                                value={el.name} id={id}
                                name="Seats[]"
                                diffPrefix={'$'}
                                diffSuffix={' Savings'}
                                onChange={handleChange}
                                display={display}
                                enabled={enabled}
                                type={(isCustomThreeRows(currentAppData) || showCustomRearCheckboxes) ? 'checkbox' : 'radio'}
                                checked={currentAppData.seat && currentAppData.seat.split(',').includes(el.name)}
                                customCompatibility={currentAppData?.check?.compatibility_custom}
                                currentAppData={currentAppData}
                            />
                                {(isCustomJump(currentAppData) &&
                                    (
                                        (el.name === 'First Row' && currentAppData.check?.compatibility_custom === 'FJ')
                                        ||
                                        (el.name === '2 Row Bundle' && currentAppData.check?.compatibility_custom === 'YJ')
                                        ||
                                        (el.name === '3 Row Bundle' && currentAppData.check?.compatibility_custom === 'TJ')
                                    )
                                ) ? (
                                    <ButtonOption key={`${el.id}-addon`}
                                        price={jumpSeatCoverPrice}
                                        value="Jump Seat Cover" id={`addon-1`} name="Addons[]"
                                        onChange={handleAddonChange}
                                        type='checkbox'
                                        checked={currentAppData.addons && currentAppData.addons.split(',').includes('Jump Seat Cover')}
                                        customClass={styles.addon_full_width}

                                    />) : ''}
                            </React.Fragment>);
                        })}
                        {currentAppData?.isFetchingCheck && (
                            <div className={localStyles.skeleton_overlay}>
                                {[...Array(3)].map((_, i) => (
                                    <div key={`skeleton-${i}`} className={localStyles.skeleton} />
                                ))}
                            </div>
                        )}
                    </div>}

                    {showCustomRearCheckboxes && !isJeepWranglerMode && (
                        <div className={`${styles.seat_type_selector}`}>
                            {customRearOptions.map((option) => {
                                const isSelected = selectedCustomRearAddons.includes(option.key);
                                const priceInfo = getCustomRearOptionPrice(option.key);
                                const displayPrice = priceInfo?.price || `$${option.price}`;
                                const displayComparePrice = priceInfo?.comparePrice || `$${option.msrp}`;
                                return (
                                    <ButtonOption
                                        key={option.key}
                                        value={option.key}
                                        displayLabel={`Add ${option.label}`}
                                        subtitle="Ships separately 3-4 weeks"
                                        price={displayPrice}
                                        comparePrice={displayComparePrice}
                                        id={`custom_rear_${option.key}`}
                                        name="CustomRearAddons[]"
                                        onChange={handleCustomRearAddonChange}
                                        checked={isSelected}
                                        display={true}
                                        enabled={true}
                                        showSavingsIcon={false}
                                        type="checkbox"
                                        customClass={styles.custom_rear}
                                        diffPrefix={'$'}
                                        diffSuffix={' Savings'}
                                        customCompatibility={currentAppData?.check?.compatibility_custom}
                                        currentAppData={currentAppData}
                                    />
                                );
                            })}
                        </div>
                    )}

                    {window.scs_show_addons ? (<VehicleAddons />) : ''}
                    

                    {savings && !window.scs_black_friday_2025 ? (
                        <div className={`${styles.savings}`}>
                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_953_3054)">
                                    <path
                                        d="M13.7499 0.110046H8.55454C8.21086 0.110046 7.7305 0.309154 7.48767 0.551803L0.364771 7.67466C-0.12159 8.16048 -0.12159 8.95698 0.364771 9.4422L5.66835 14.7456C6.15361 15.2314 6.94934 15.2314 7.43534 14.745L14.5582 7.62328C14.8008 7.38067 15 6.89955 15 6.55659V1.3601C15 0.672725 14.4373 0.110046 13.7499 0.110046ZM11.2498 5.11007C10.5594 5.11007 9.99975 4.54981 9.99975 3.86002C9.99975 3.16909 10.5594 2.60997 11.2498 2.60997C11.9402 2.60997 12.5 3.16909 12.5 3.86002C12.5001 4.54981 11.9402 5.11007 11.2498 5.11007Z"
                                        fill="black" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_953_3054">
                                        <rect width="15" height="15" fill="white"
                                            transform="translate(0 0.109924)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            You Saved: <span
                                className={`${styles.savings_price}`} data-testid="savings-price">{savings}</span> ({(savings1 / comparePrice1 * 100).toFixed(0)}%)
                        </div>
                    ) : ''}
                    </>)}

                </div>

            </section>


            {window.scs_ultimate_upgrade && currentAppData?.seat && currentAppData?.seat != '' ? (
                <section
                    className={`${styles.section__step} ${styles.section__step_ult} ${currentAppData?.step == 2 ? styles.section_active : ''}`}
                    id="step_2_ultimate">
                    <h2>Ultimate Seat Cover Protection Upgrade</h2>
                    <div className={`${styles.ultimate_wrapper}`}>
                        <img src={'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ultimate-offer.png?v=1759937838'} style={{ maxWidth: '118px' }} />
                        <ul className={`${styles.ultimate_benefits}`}>
                            <li>2 year Extended Warranty</li>
                            <li>Matching Steering Wheel Cover</li>
                            <li>Seat Cover Care Kit</li>
                        </ul>
                    </div>
                    <React.Fragment key={`wrapper-ultimate-upgrade`}><ButtonOption key={'ultimate-upgrade'}
                        comparePrice={`${formatShopifyMoney(299)}`}
                        price={`Only ${formatShopifyMoney(99)}`}
                        showSavingsIcon={true}
                        value={'Claim This Deal'}
                        id={'ultimate_upgrade'}
                        name="ultimate_upgrade"
                        onChange={handleChangeUltimateUpgrade}
                        customClass={styles.ultimate_upgrade}
                        display={true}
                        enabled={true}
                        type={'checkbox'}
                        checked={currentAppData?.ultimate_upgrade == true}

                    />

                    </React.Fragment>

                </section>
            ) : ''}


        </>
    </>);
}